/* 
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */
if(!window.GS) GS={};
if(!window.GS.Toolbar) GS.Toolbar={};
if(!window.GS.Toolbar.Frame) GS.Toolbar.Frame={};
GS.Toolbar.Frame.LevelsTools=new Class({
    Extends: GS.Toolbar.Tools,
    class_name:'GS.Toolbar.Frame.LevelsTools',
    options:{
        'wrapper': null,
        'class':'submenu full',
        'lexico':{'f':'up one level','b':'back one level','fa':'to front','ba':'to back'},
        'toolbar':null
    },
    controlled:null,
    initialize:function(conf){
       this.options.lexico=Locale.get('Toolbar.levels_menu');
       this.parent(conf);
    }
});


GS.Toolbar.Frame.LevelsTools.prototype.updatePermissions=function(p){
    try{

        var d=(p['zIndex']) ? 'block' : 'none';
        //var d=(p['zIndex']) ? 1 : 0;
        this.options.wrapper.setStyle('display',d);
        this.options.wrapper.store('status',1);
        //if(s) this.toolbar.fireEvent('show');
    }catch(err){
        console.warn(err);
    }
};

GS.Toolbar.Frame.LevelsTools.prototype.menuTMPL=function(){
    var out='';
    out+='<li class="send-to-front" data-type="send-to-front" title="{fa_title}"><label>{fa}</label></li>';
    out+='<li class="separator-h"></li>';
    out+='<li class="send-to-front-one-level" data-type="send-to-front-one-level"  title="{f_title}"><label>{f}</label></li>';
    out+='<li class="separator-h"></li>';
    out+='<li class="send-to-back-one-level" data-type="send-to-back-one-level"  title="{b_title}"><label>{b}</label></li>';
    out+='<li class="separator-h"></li>';
    out+='<li class="send-to-back" data-type="send-to-back"  title="{ba_title}"><label>{ba}</label></li>';
    return out;
};